import React from 'react';
import { FadeIn } from './FadeIn';
export function PaolaSection() {
  return <section className="py-8 md:py-24 px-4 bg-white" data-id="element-370">
      <div className="max-w-4xl mx-auto" data-id="element-371">
        <FadeIn data-id="element-372">
          <div className="bg-white rounded-3xl p-6 md:p-12 border border-green-mint/30 shadow-soft flex flex-col md:flex-row gap-8 md:gap-12 items-center md:items-start" data-id="element-373">
            {/* Image Mobile (Top) / Desktop (Left) */}
            <div className="w-48 h-48 md:w-64 md:h-64 shrink-0 relative" data-id="element-374">
              <div className="absolute inset-0 bg-green-lime/20 rounded-full translate-x-2 translate-y-2" data-id="element-375"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3K93miQc9TBYs5o5eFxYBa/paolalibroinmunidad.jpg" alt="Paola" className="w-full h-full object-cover rounded-full relative z-10 border-4 border-white shadow-md" data-id="element-376" />
            </div>

            {/* Content */}
            <div className="flex-1 text-center md:text-left" data-id="element-377">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-green-deep mb-2" data-id="element-378">
                Hola, soy Paola.
              </h2>
              <p className="font-bold text-text-main text-lg md:text-xl mb-6" data-id="element-379">
                Y antes de crear este protocolo, fui la mamá que más lo
                necesitaba.
              </p>

              <div className="space-y-4 text-text-main/80 font-body text-base leading-relaxed mb-8" data-id="element-380">
                <p data-id="element-381">
                  Mi hijo Giacomo tuvo su primer ciclo de antibióticos a los 8
                  meses. A los 2 años, ya había tenido 6.
                </p>
                <p data-id="element-382">
                  Cada invierno era lo mismo: jardín, moco, fiebre, consultorio,
                  antibiótico. Rinse and repeat.
                </p>
                <p data-id="element-383">
                  El pediatra era buenísimo. Hacía lo que podía. Pero nadie —{' '}
                  <strong data-id="element-384">nadie</strong> — me preguntó jamás qué estaba comiendo
                  Giacomo. Cómo estaba su intestino. Si había algo que yo
                  pudiera hacer antes de que llegara la infección.
                </p>
                <p data-id="element-385">
                  <strong data-id="element-386">Entonces lo busqué sola.</strong> Dos años de
                  investigación. Cientos de horas leyendo estudios sobre
                  microbioma, probióticos y compuestos antivirales naturales. Y
                  todo eso lo fui aplicando, de a poco,{' '}
                  <strong data-id="element-387">en la cocina de mi casa.</strong>
                </p>
              </div>

              <div className="bg-green-mint/20 p-6 rounded-2xl border-l-4 border-green-lime mb-8 relative" data-id="element-388">
                <span className="absolute -top-4 -left-2 text-6xl text-green-lime/30 font-serif" data-id="element-389">
                  "
                </span>
                <p className="font-heading font-bold text-xl text-green-deep relative z-10 italic" data-id="element-390">
                  A los 90 días, el pediatra me preguntó:
                  <br data-id="element-391" />
                  "Paola, ¿qué cambiaste? Porque este nene no es el mismo."
                </p>
              </div>

              <div className="space-y-4 text-text-main/80 font-body text-base leading-relaxed mb-8" data-id="element-392">
                <p data-id="element-393">
                  Decidí documentar todo en el manual que yo hubiera necesitado
                  aquella noche que me senté en una silla de hospital con
                  Giacomo dormido y un suero en el brazo.
                </p>
                <p className="font-bold text-text-main" data-id="element-394">
                  No soy médica. Soy una mamá que encontró el sistema — y lo
                  escribió para vos.
                </p>
              </div>

              <div className="font-heading italic text-xl text-green-deep" data-id="element-395">
                Con cariño,
                <br data-id="element-396" />
                <span className="font-bold text-2xl mt-2 inline-block" data-id="element-397">
                  — Paola 🌿
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}